import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ShoppingCartService } from '../../../services/shopping-cart.service';
import { Subscription } from 'rxjs';
import { ShoppingCart } from '../../../models/shopping-cart.model';
import { CartDetailViewModel } from '../../../models/cart-item.model';
import { FileService } from '../../../services/file.service';
import { CommonService } from '../../../services/common.service';
import { CheckOutService } from '../../../services/checkout.service';
import { CheckoutViewModel, SubscriptionSalesType, CheckoutStatusModel } from '../../../models/check-out.model';
import { SKUSearchViewModel } from '../../../models/search-result.model';
import { CartResponse } from '../../../models/api-response.model';
import { ProductDetail } from '../../../models/product-detail.model';
import { getStockOnHand } from '../../../shared/tools.collections';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TermsAndConditionsComponent } from '../../../popup-collection/terms-and-conditions/terms-and-conditions.component';
import { Sort } from '@angular/material/sort';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import { DeleteConfirmComponent } from '../../../popup-collection/delete-confirm/delete-confirm.component';
import { CartQuote, CartStockCodes } from '../../../models/quote.model';
import { ProductService } from '../../../services/product.service';
import { CurrentUserModel } from '../../../models/account-ledger.model';
import { AuthService } from '../../../services/auth.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../reducers';
import { DeleteShoppingCart, LoadShoppingCartItem, UpdateShoppingCartItemQty, DeleteShoppingCartItem, UpdateShoppingCart, CloneShoppingCart, ShareShoppingCart, UpdateShoppingCartSuccess, ShoppingCartActionTypes } from '../../../actions/shoppingcart.actions';
import { getShoppingCartView, getShoppintCartItemLoading, getShoppingCarts, getShoppingCartLoaded, getSelectedShoppingCart } from '../../../reducers/shoppingcart.reducer';
import { ChildHeaderComponent } from '../../../child-header/child-header.component';
import { Actions, ofType } from '@ngrx/effects';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';


@Component({
  selector: 'app-cart-summary',
  templateUrl: './cart-summary.component.html',
  styleUrls: ['./cart-summary.component.css']
})

export class CartSummaryComponent implements OnInit, OnDestroy {

  // #region variables

  setFullWindow = false;
  loadContent = false;
  title = 'My Carts';
  shoppingCarts: ShoppingCart[];
  cartItems: CartDetailViewModel[] = [];
  cartItemsFilter: CartDetailViewModel[] = [];
  sortedData: CartDetailViewModel[] = [];
  totalPrice = 0;
  url: string;

  public locations = [{ name: 'Delivery', value: 'delivery' }];
  public donationOptionsList = [
    {
      value: 1,
      stockCode: 'Tree1',
    },
    {
      value: 5,
      stockCode: 'Tree5',
    },
    {
      value: 10,
      stockCode: 'Tree10',
    },
  ];
  public  selectedDonationValue = 0;

  newCartStatus = 0;
  cartId: string;
  cartName: string;
  closesub$: Subscription;
  checkoutViewModel: CheckoutViewModel;

  editCartId: string;
  editCartName: string;

  productDetailArray: ProductDetail[] = [];

  getFullStockProductDetails: ProductDetail;
  productDetails: ProductDetail[];

  searchFilter = '';

  searchKeyWord: string;
  cartSearchResult: SKUSearchViewModel[] = [];

  sohType: string;
  minMaxInfo = '';

  checkStatus = true;

  backgroundClass: string;
  colorIndex: number;
  previousRef: string;
  hasSliderClicked: boolean;
  checkoutInitiated = false;
  showCheckoutSummary = true;
  checkoutStatus: CheckoutStatusModel;
  closeResult: string;
  modalReference = null;
  currentUserModel: CurrentUserModel;
  ngUnsubscribe: Subject<void> = new Subject<void>();

  cartToQuote: CartQuote = {};

  showDeleteButton = true;
  isAnnuityCart = false;

  loginId: string;
  selectedCartLoginId: string;
  // #endregion
  @ViewChild('childHeader') private childHeader: ChildHeaderComponent;
  shippingMethodControl = new FormControl("delivery");

  public isPickUp = false;
  
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private shoppingCartService: ShoppingCartService,
    private fileService: FileService,
    public commonService: CommonService,
    private checkOutService: CheckOutService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private authService: AuthService,
    public dialog: MatDialog,
    public productService: ProductService,
    public store: Store<AppState>,
    private _actions$: Actions
  ) {
    checkOutService.changeEmitted$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      res => {
        this.checkoutInitiated = res.hasChosenCheckout;
      });

  }

  ngOnInit() {

    this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe)).subscribe(user => {
      this.loginId = user.loginId;
    });

    this.commonService.getWarehouseList().pipe(takeUntil(this.ngUnsubscribe)).subscribe(locations => {
      this.locations = [ ...this.locations, ...locations.map(l => {
        return {name: l.out_whse_description, value: l.out_whse_code}
      })]
    });

    this.checkoutStatus = {
      currentStep: '',
      firstStep: '',
      hasChosenCheckout: false,
      collectOrder: false,
      tenantDetailsRequired: ''
    };


    this.activatedRoute.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
      {
        next: () => {
          $('#levelOne').animate({ scrollLeft: -($('#levelOne').width()) }, 400);
        },
        error: (error: string) => this.commonService.implementToast(error, "Error"),
        complete: () => this.loadContent = true
      }
    );

    this.activatedRoute.paramMap
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (param) => {
          this.cartId = param.get('id');
          const cartname = decodeURIComponent(param.get('cartName'));
          this.cartName = cartname;
          this.commonService.createCookie('CartId', this.cartId.toString(), 7);
          this.checkOutService.skipEndUserStep$.next(false);
          if (this.router.url !== `/myCarts/cart/${this.cartId}/${decodeURIComponent(cartname)}`) {
            if (this.router.url.includes('order-confirmation') || this.router.url.includes('payment-method')) {
              this.showCheckoutSummary = false;
            }
            this.loadContent = true;  // set to true to avoid load two loading screen at the same time
          }
    
          this.authService.getLoginInfo()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((res: CurrentUserModel) => {
            this.currentUserModel = res;
    
            this.commonService.createCookie('CompanyCode', this.currentUserModel.companyCode, 7);
          },
          (error: any) => {
              console.error(error);
            });
    
          const currentAnnuityCartId = localStorage.getItem('annuityCartId');
          // check if it is annuity cart.
          // NOTE: annuity carts are not showing in the ngrx store, they are temp carts
          if (currentAnnuityCartId && currentAnnuityCartId === this.cartId) {
            this.isAnnuityCart = true;
            this.getShoppingCarts();
          } else {
            this.store.select(getShoppingCartLoaded)
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(isLoaded => {
                if (isLoaded) {
                  // load shoppingcart items
                  this.store.dispatch(new LoadShoppingCartItem({ cartId: this.commonService.toNumber(this.cartId), shippingMethod: this.shippingMethodControl.value}));
              
                  this.store.select(getShoppingCartView)
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe(ci => {
                      if (ci.cartId === this.cartId) {
                        this.processCartItems(ci?.items);
                      }
                    });
              
                  this.store.select(getShoppingCarts).subscribe(sc => {
                    this.processShoppingCarts(sc);
                  },
                    (error: any) => {
                      console.error(error);
                      this.loadContent = true;
                    });
              
                  this.store.select(getShoppintCartItemLoading)
                    .pipe(takeUntil(this.ngUnsubscribe))
                    .subscribe((loading) => {
                      this.loadContent = !loading;
                    });
                }
            });
          };
      },
      error: (error: string) => this.commonService.implementToast(error, "Error") 
    });


    this.store.select(getSelectedShoppingCart).pipe(takeUntil(this.ngUnsubscribe)).subscribe(sc => {

      if (sc) {
        this.selectedCartLoginId = sc.loginId;
      }

      if (sc && !this.router.url.includes('product') && !this.router.url.includes('summary-order') && !this.router.url.includes('order-confirmation') && !this.isAnnuityCart) {
        this.router.navigate([`/myCarts/cart/${sc.cartId}/${sc.cartName}`]);
      }

      // if (sc && !this.router.url.includes('product') || (!this.router.url.includes('summary-order') || !this.router.url.includes('order-confirmation')) && !this.isAnnuityCart) {
      //   this.router.navigate([`/myCarts/cart/${sc.cartId}/${sc.cartName}`]);
      // }

    });

    this.store.select(getShoppingCarts).pipe(takeUntil(this.ngUnsubscribe)).subscribe(carts => {
      if (carts.length === 1) {

        this.showDeleteButton = false;

      } else {

        this.showDeleteButton = true;

      }

    });

    this._actions$.pipe(ofType(ShoppingCartActionTypes.UpdateShoppingCartSuccess)).subscribe((val: UpdateShoppingCartSuccess) => {
      this.cartName = val.payload.cartName;
      const urlArr = this.router.url.split("/", 4);
      const newUrl = urlArr.join("/") + "/" + this.cartName;
      this.router.navigate([newUrl], { replaceUrl: true })
    })

    // this.activatedRoute.paramMap.takeUntil(this.ngUnsubscribe).subscribe(param => {
    //   this.cartId = param.get('id');
    //   const cartname = decodeURIComponent(param.get('cartName'));
    //   this.commonService.createCookie('CartId', this.cartId.toString(), 7);

    //   if (this.router.url !== `/myCarts/cart/${this.cartId}/${decodeURIComponent(cartname)}`) {
    //     if (this.router.url.includes('order-confirmation') || this.router.url.includes('payment-method')) {
    //       this.showCheckoutSummary = false;
    //     }
    //     this.loadContent = true;  // set to true to avoid load two loading screen at the same time
    //   }
    //   this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
    //     this.currentUserModel = res;
    //     this.commonService.createCookie('CompanyCode', this.currentUserModel.companyCode, 7);
    //   },
    //     (error: any) => {
    //       console.error(error);
    //     });
    //   this.getShoppingCarts();
    // },
    //   (error: any) => {
    //     console.error(error);
    //     this.loadContent = true;
    //   });
  }

  private processCartItems(cartItems: CartDetailViewModel[]): void {
    this.totalPrice = 0;
    this.selectedDonationValue = 0;
    if (cartItems?.length != 0) {
      const nonDonations = cartItems.filter(i => i.cartItemID > 0 && (i.stockCode.toLowerCase().indexOf('donation') === -1)).map(item => Object.assign({}, item));
      const donations =  cartItems.filter(i => i.cartItemID > 0 && (i.stockCode.toLowerCase().indexOf('donation') === 0)).map(item => Object.assign({}, item));
      this.cartItems = [ ...nonDonations, ...donations ]
      this.cartItemsFilter = [ ...this.cartItems ];
      this.sortedData = [ ...this.cartItemsFilter ];
      this.cartItems.map(val => {
        this.totalPrice += this.commonService.toNumber(val.subTotal);
      });
      this.setBackgroundClass(this.cartItemsFilter);

      if (donations?.length != 0) {
        this.selectedDonationValue = donations[0].unitCost;
      }
    } else {
      this.cartItems = [];
      this.cartItemsFilter = this.cartItems;
      this.sortedData = [];
    }
  }
  private processShoppingCarts(shoppingCarts: ShoppingCart[]): void {
    if (shoppingCarts.filter(cart => cart.cartId.toString() === this.cartId).length > 0) {
      this.shoppingCarts = shoppingCarts;
      this.newCartStatus = this.shoppingCarts.filter(cart => cart.cartId.toString() === this.cartId)[0].status;
      this.cartName = decodeURIComponent(this.shoppingCarts.filter(cart => cart.cartId.toString() === this.cartId)[0].cartName);
    }
  }

  private getShoppingCarts(branchCode: string = "") {
    this.loadContent = false;
    this.shoppingCartService.monitorCartId(this.commonService.toNumber(this.cartId));
    this.cartItemsFilter = [];
    this.cartItems = [];
    this.sortedData = [];
    this.totalPrice = 0;
    this.shoppingCartService
      .getAllItemsFromShoppingCart(this.cartId, true, branchCode)
      .subscribe((ci: CartDetailViewModel[]) => {
        this.processCartItems(ci);
        this.loadContent = true;
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });

    // This is used to check the share status of the current shopping cart
    // this.shoppingCartService
    //   .cachedShoppingCart()
    //   .subscribe(sc => {

    //     if (sc.filter(cart => cart.cartId.toString() === this.cartId).length > 0) {
    //       this.shoppingCarts = sc;
    //       this.newCartStatus = this.shoppingCarts.filter(cart => cart.cartId.toString() === this.cartId)[0].status;
    //       this.cartName = decodeURIComponent(this.shoppingCarts.filter(cart => cart.cartId.toString() === this.cartId)[0].cartName);
    //     }
    //   },
    //     (error: any) => {
    //       console.error(error);
    //       this.loadContent = true;
    //     });
  }

  // getShoppingCarts(branchCode: string = "") {
  //   this.loadContent = false;
  //   this.shoppingCartService.monitorCartId(toNumber(this.cartId));
  //   this.cartItemsFilter = [];
  //   this.cartItems = [];
  //   this.sortedData = [];
  //   this.totalPrice = 0;

  //   this.shoppingCartService
  //     .getAllItemsFromShoppingCart(this.cartId, true, branchCode)
  //     .subscribe((ci: CartDetailViewModel[]) => {
  //       if (ci && ci.length > 0 && ci[0]) {
  //         this.cartItems = ci.filter(i => i.cartItemID > 0);
  //         this.cartItemsFilter = this.cartItems;
  //         this.sortedData = this.cartItemsFilter.slice();
  //         this.cartItems.map(val => {
  //           this.totalPrice += toNumber(val.subTotal);
  //         });
  //         this.setBackgroundClass(this.cartItemsFilter);
  //         this.loadContent = true;
  //       } else {
  //         this.loadContent = true;
  //         this.cartItems = [];
  //         this.cartItemsFilter = this.cartItems;
  //         this.sortedData = [];
  //       }
  //     },
  //       (error: any) => {
  //         console.error(error);
  //         this.loadContent = true;
  //       });

    // This is used to check the share status of the current shopping cart
    // this.shoppingCartService
    //   .cachedShoppingCart()
    //   .subscribe(sc => {

    //     if (sc.filter(cart => cart.cartId.toString() === this.cartId).length > 0) {
    //       this.shoppingCarts = sc;
    //       this.newCartStatus = this.shoppingCarts.filter(cart => cart.cartId.toString() === this.cartId)[0].status;
    //       this.cartName = decodeURIComponent(this.shoppingCarts.filter(cart => cart.cartId.toString() === this.cartId)[0].cartName);
    //     }
    //   },
    //     (error: any) => {
    //       console.error(error);
    //       this.loadContent = true;
    //     });
  // }

  updateItemQty(cartItem: CartDetailViewModel, index: number): void {
    this.store.dispatch(new UpdateShoppingCartItemQty(cartItem));
    // this.loadContent = false;
    // if ($('.qtyInput' + cartItem.cartItemID).val() === '') {
    //   cartItem.quantity = 0;
    // }
    // this.shoppingCartService.GetItemStatusQuantity(this.cartId, cartItem.cartItemID, cartItem.stockCode, cartItem.quantity).subscribe((res: CartResponse) => {
    //   if (res.result === 'Success') {
    //     if (!res.boolResult && res.message) {
    //       this.shoppingCartService
    //         .getAllItemsFromShoppingCart(this.cartId, true)
    //         .subscribe((ci: CartDetailViewModel[]) => {
    //           this.totalPrice = 0;
    //           if (ci && ci.length > 0 && ci[0]) {
    //             this.cartItems = ci;
    //             this.cartItemsFilter = this.cartItems;
    //             this.sortedData = this.cartItemsFilter.slice();
    //             this.cartItems.map((value, key) => {
    //               this.totalPrice += toNumber(value.subTotal);
    //             });
    //             this.loadContent = true;
    //           } else {
    //             this.cartItems = [];
    //             this.cartItemsFilter = this.cartItems;
    //             this.sortedData = this.cartItemsFilter.slice();
    //             this.loadContent = true;
    //           }
    //         },
    //           (error: any) => {
    //             console.error(error);
    //             this.loadContent = true;
    //           });
    //       this.commonService.showError('.qtyInput' + cartItem.cartItemID, res.message, 'right');
    //       this.loadContent = true;
    //     } else if (res.boolResult) {
    //       if (res.message) { this.commonService.showError('.qtyInput' + cartItem.cartItemID, res.message, 'right'); }
    //       this.shoppingCartService
    //         .UpdateItemQuantity(cartItem)
    //         .subscribe((result: CartResponse) => {
    //           if (result.result === 'Success') {
    //             this.shoppingCartService
    //               .getAllItemsFromShoppingCart(this.cartId, true)
    //               .subscribe((ci: CartDetailViewModel[]) => {
    //                 this.totalPrice = 0;
    //                 if (ci && ci.length > 0 && ci[0]) {
    //                   this.cartItems = ci;
    //                   this.cartItemsFilter = this.cartItems;
    //                   this.sortedData = this.cartItemsFilter.slice();
    //                   this.cartItems.map((value, key) => {
    //                     this.totalPrice += toNumber(value.subTotal);
    //                   });
    //                   this.loadContent = true;
    //                 } else {
    //                   this.cartItems = [];
    //                   this.cartItemsFilter = this.cartItems;
    //                   this.sortedData = this.cartItemsFilter.slice();
    //                   this.loadContent = true;
    //                 }
    //               },
    //                 (error: any) => {
    //                   console.error(error);
    //                   this.loadContent = true;
    //                 });

    //             this.shoppingCartService
    //               .getShoppingCart()
    //               .subscribe((sc: ShoppingCart[]) => {
    //                 this.shoppingCarts = sc;
    //                 this.shoppingCartService
    //                   .monitorNumberOfItemsChange(this.shoppingCarts.filter(i => i.cartId.toString() === this.cartId)[0].totalQuantity);
    //               },
    //                 (error: any) => {
    //                   console.error(error);
    //                   this.loadContent = true;
    //                 });
    //           } else {
    //             this.commonService.showResult('.qtyInput' + cartItem.cartItemID, result.message, 'right');
    //             this.loadContent = true;
    //           }
    //         },
    //           (error: any) => {
    //             console.error(error);
    //             this.loadContent = true;
    //           });
    //     } else if (res.stockStatus === 'o' && toNumber(res.qty) > 0 && toNumber(res.qty) < toNumber(cartItem.quantity)) {
    //       this.commonService.showError('.qtyInput' + cartItem.cartItemID, 'We only have ' + res.qty + ' of this obsolete part left. Please adjust your ordered quantity.', 'right');
    //       this.loadContent = true;
    //     }
    //   } else {
    //     this.shoppingCartService
    //       .getAllItemsFromShoppingCart(this.cartId, true)
    //       .subscribe((ci: CartDetailViewModel[]) => {
    //         this.totalPrice = 0;
    //         if (ci && ci.length > 0 && ci[0]) {
    //           this.cartItems = ci;
    //           this.cartItemsFilter = this.cartItems;
    //           this.sortedData = this.cartItemsFilter.slice();
    //           this.cartItems.map((value, key) => {
    //             this.totalPrice += toNumber(value.subTotal);
    //           });
    //           this.loadContent = true;
    //         } else {
    //           this.cartItems = [];
    //           this.cartItemsFilter = this.cartItems;
    //           this.sortedData = this.cartItemsFilter.slice();
    //           this.loadContent = true;
    //         }
    //       },
    //         (error: any) => {
    //           console.error(error);
    //           this.loadContent = true;
    //         });

    //     this.shoppingCartService
    //       .getShoppingCart()
    //       .subscribe((sc: ShoppingCart[]) => {
    //         this.shoppingCarts = sc;
    //         this.shoppingCartService
    //           .monitorNumberOfItemsChange(this.shoppingCarts.filter(i => i.cartId.toString() === this.cartId)[0].totalQuantity);
    //       },
    //         (error: any) => {
    //           console.error(error);
    //           this.loadContent = true;
    //         });
    //     this.commonService.showError('.qtyInput' + cartItem.cartItemID, res.message, 'right');
    //     this.loadContent = true;
    //   }
    // },
    //   (error: any) => {
    //     console.error(error);
    //     this.loadContent = true;
    //   });
  }

  noRedirect(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  deleteItem(event, cartItem: CartDetailViewModel) {
    this.store.dispatch(new DeleteShoppingCartItem(cartItem));
    // this.loadContent = false;
    // this.shoppingCartService.deleteItemFromShoppingCart(cartItem.cartItemID).subscribe((res: ApiResponse) => {
    // },
    //   (error: any) => {
    //     this.commonService.implementToast(error, 'Error');
    //     this.loadContent = true;
    //   });
  }

  checkProductDetail(stockCode: string): void {
    stockCode = encodeURIComponent(stockCode);
    this.router.navigate([`product/${stockCode}`], { relativeTo: this.activatedRoute });
  }

  setEditCart(cartId: string): void {
    this.editCartId = cartId.toString();
    this.editCartName = this.shoppingCarts.filter(shoppingCart => shoppingCart.cartId.toString() === this.cartId)[0].cartName;
  }

  filterCartItems(): void {
    if (this.searchFilter) {
      const searchFiled = this.searchFilter.toLowerCase();
      this.cartItemsFilter = this.cartItems.filter(cartItem => cartItem.itemDescription.toLowerCase().includes(searchFiled)
        || cartItem.stockOnHand.toString().includes(searchFiled) || cartItem.stockCode.toLowerCase().includes(searchFiled)
        || cartItem.status.toLowerCase().includes(searchFiled) || cartItem.unitCost.toString().includes(searchFiled)
      );
    } else {
      this.cartItemsFilter = this.cartItems;
    }
    this.sortedData = this.cartItemsFilter.slice();
  }

  validateCartName(event: any): void {
    const pattern: RegExp = /[!@#$%^&*(),.?":{}|<>\s]/g;
    if (event.inputType === 'insertText') {
      // let inputChar = String.fromCharCode(event.data);
      if (pattern.test(event.data)) {
        // invalid character, prevent input
        event.target.value = event.target.value.replace(pattern, '');
      }
    } else if (event.inputType === 'insertFromPaste') {
      if (pattern.test(event.target.value)) {
        // invalid input added from Paste
        event.target.value = event.target.value.replace(pattern, '');
      }
    }
  }

  confirmCartNameValue(cartName: string, cartId: string): void {
    // cartName = this.editCartName;
    // this.editCartId = '0';
    this.store.dispatch(new UpdateShoppingCart({ cartId: this.commonService.toNumber(cartId), cartName: cartName }));
    // this.loadContent = false;
    // this.editCartId = '0';
    // this.shoppingCartService.updateCartName(cartName, toNumber(cartId))
    //   .subscribe((success: ApiResponse) => {
    //     if (success.status) {
    //       this.shoppingCartService.monitorCartNameChange(cartName);
    //       this.loadContent = true;
    //       this.cartName = cartName;
    //       this.router.navigateByUrl('/myCarts/cart/' + this.cartId + '/' + this.cartName);
    //     } else {
    //       this.commonService.showError('.edit-input', success.responseMessage, 'right');
    //       this.loadContent = true;
    //     }
    //   },
    //     (error: any) => {
    //       this.loadContent = true;
    //       console.error(error);
    //     });
  }

  deleteShoppingCart(cartId: string): void {
    const dialogRef = this.dialog.open(DeleteConfirmComponent, {
      width: '500px',
      height: '175px',
      panelClass: 'mat-dialog-wrapper'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.store.dispatch(new DeleteShoppingCart(this.commonService.toNumber(this.cartId)));
        // this.shoppingCartService.deleteShoppingCart(toNumber(this.cartId))
        //   .subscribe(success => {
        //     if (success) {
        //       this.shoppingCartService.getShoppingCart().subscribe(sc => {
        //         this.shoppingCarts = sc;
        //         this.shoppingCartService.setCacheShoppingCart(sc);
        //         if (sc.length !== 0) {
        //           if (this.cartId === cartId) {
        //             this.shoppingCartService.monitorCartId(this.shoppingCarts[0].cartId);
        //             // this.shoppingCartService.monitorCartIdChange(this.shoppingCarts[0].cartId);
        //             this.commonService.createCookie('CartId', this.shoppingCarts[0].cartId.toString(), 7);
        //           }
        //           this.shoppingCartService.monitorCartNameChange(cartId.toString() + cartName);
        //           this.close();
        //           this.loadContent = true;
        //         } else {
        //           this.loadContent = true;
        //           this.close();
        //         }
        //       },
        //         (error: any) => {
        //           console.error(error);
        //           this.loadContent = true;
        //         });
        //     } else {
        //       this.commonService.showError('#delete-icon', 'Fail to delete cart', 'right');
        //     }
        //   },
        //     (error: any) => {
        //       console.error(error);
        //       this.loadContent = true;
        //     });
      }
    });
  }

  downloadCartToExcel(): void {
    this.loadContent = false;
    this.fileService.exportCartToExcel(this.cartId).subscribe(data => {
      // const loginId = this.commonService.readCookie('LoginId');
      const fileName = `DD_ShoppingCartItems_${this.cartName}.xlsx`;

      this.fileService.saveAsExcelFile(data, fileName);
      this.loadContent = true;


    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });
  }

  // downloadCartAsExcel(): void{
  //   let form = document.getElementById('downloadCartForm') as HTMLFormElement;
  //   if (!form) {
  //     form = document.createElement('form') as HTMLFormElement;
  //     form.id = 'downloadCartForm';
  //     form.action = '/ExportExcel/exportcarttoexcel?cartId=' + this.cartId;
  //     form.method = 'POST';
  //     form.enctype = 'multipart/form-data';
  //     document.body.appendChild(form);
  //     this.commonService.showSuccess("#download", "File will be downloaded shortly", "right");
  //     $('#downloadCartForm').submit();
  //     document.body.removeChild(form);
  //   }
  // }

  cloneCart(cartId: string): void {
    this.store.dispatch(new CloneShoppingCart(parseInt(cartId)));
    // this.loadContent = false;
    // this.shoppingCartService.DuplicateCart(cartId).subscribe((res: number) => {
    //   this.loadContent = true;
    //   if (res) {
    //     this.shoppingCartService.monitorCartIdChange(res);
    //     this.shoppingCartService.getCartName(res.toString()).subscribe((name: string) => {
    //       this.router.navigateByUrl('/myCarts/cart/' + res + '/' + name);
    //     },
    //       (error: any) => {
    //         console.error(error);
    //         this.loadContent = true;
    //       });
    //   } else {
    //     this.commonService.showError('#shoppingcart-icon', 'Fail to clone cart', 'right');
    //   }
    // },
    //   (error: any) => {
    //     console.error(error);
    //     this.loadContent = true;
    //   });
  }

  shareCart(): void {
    // this.loadContent = false;
    this.hasSliderClicked = !this.hasSliderClicked;
    this.store.dispatch(new ShareShoppingCart(this.cartId));
    // this.shoppingCartService.shareCartToggle(this.cartId).subscribe((res: number) => {
    //   this.newCartStatus = res;
    //   this.shoppingCartService.monitorStatusChange(this.newCartStatus);
    //   this.loadContent = true;
    // },
    //   (error: any) => {
    //     console.error(error);
    //     this.loadContent = true;
    //   });
  }


  checkOutCart(): void {

    this.loadContent = false;
    this.checkStatus = (this.cartItems.filter(cartItem => (cartItem?.stockCurrentStatus?.toUpperCase() === 'O' || cartItem?.stockCurrentStatus?.toUpperCase() === 'T') && cartItem?.stockOnHand < cartItem?.quantity)?.length !== 0) ? false : true;
    const hasRestricted = (this.cartItems.filter(cartItem => (cartItem?.status?.toUpperCase() === 'RESTRICTED')).length !== 0) ? true : false;

    //check pick up location availability
    let hasOutOfStock = false;
    if (this.isPickUp) {
      hasOutOfStock = this.cartItems.every(cartItem => (cartItem.branch_AvailStock == "0"));
    } 
    if (!this.checkStatus) {
      this.loadContent = true;
      this.commonService.implementToast('One or more items in your cart is obsolete. Please adjust your cart accordingly.', 'Error');
    } else if (hasRestricted) {
      this.loadContent = true;
      this.commonService.implementToast('One or more items in your cart is Restricted. Please adjust your cart accordingly.', 'Error');
    } else if (hasOutOfStock) {
      this.loadContent = true;
      const location = this.locations.find(l => l.value === this.shippingMethodControl?.value)?.name;
      this.commonService.implementToast(`This location '${ location }' does not have enough stock for pickup`, 'Error');
    } else {
      localStorage.setItem('DeliveryMethod', this.shippingMethodControl.value)
      this.checkOutService.CartCheckout(this.commonService.toNumber(this.cartId)).subscribe((res: CheckoutViewModel) => {
        this.checkoutViewModel = res;
        // emit checkoutviewmodel
        this.checkOutService.monitorCurrentCheckoutViewModel(this.checkoutViewModel);

        this.checkOutService.AcceptTermsAndConditions().subscribe((response: CartResponse) => {
          if (response.result === 'Success') {
            this.loadContent = true;
            const dialogRef = this.dialog.open(TermsAndConditionsComponent, {
              width: '800px',
              disableClose: true,
              panelClass: 'mat-dialog-wrapper'
            });

            dialogRef.afterClosed().subscribe(result => {
              if (result) {
                this.checkoutInitiated = true;
                if (this.checkoutStatus) {
                  this.checkoutStatus.hasChosenCheckout = this.checkoutInitiated;
                  this.checkoutStatus.firstStep = this.checkoutViewModel.firstStep;
                  this.checkoutStatus.currentStep = this.checkoutViewModel.firstStep;
                }
                // this child component will be emitting a change every time this function is called
                this.checkOutService.emitChange(this.checkoutStatus);
                // Load section according to the controller selection
                if (this.checkoutViewModel.firstStep === 'TENANT') {
                  this.router.navigate(['tenant'], { relativeTo: this.activatedRoute });
                } else if (this.checkoutViewModel.firstStep === 'ADDRESS') {
                  this.router.navigate(['ship-address'], { relativeTo: this.activatedRoute });
                } else if (this.checkoutViewModel.firstStep === 'ENDUSER') {
                  this.router.navigate(['end-user'], { relativeTo: this.activatedRoute });
                } else if (this.checkoutViewModel.firstStep === 'PAYMENT') {
                  // NZ site is not using donation page
                  // if (this.currentUserModel.isAU) {
                  //   this.router.navigate(['donation'], { relativeTo: this.activatedRoute });
                  // } else {
                    this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute });
                  // }
                } else if (this.checkoutViewModel.firstStep === 'NOENDUSER') {
                  this.router.navigate(['ship-address'], { relativeTo: this.activatedRoute });
                }
              }
            });
          } else {
            this.checkoutInitiated = true;
            if (this.checkoutStatus) {
              this.checkoutStatus.hasChosenCheckout = this.checkoutInitiated;
              this.checkoutStatus.firstStep = this.checkoutViewModel.firstStep;
              this.checkoutStatus.currentStep = this.checkoutViewModel.firstStep;
            }
            // this child component will be emitting a change every time this function is called
            this.checkOutService.emitChange(this.checkoutStatus);
            this.loadContent = true;
            // Load section according to the controller selection
            if (this.checkoutViewModel.firstStep === 'TENANT') {
              this.router.navigate(['tenant'], { relativeTo: this.activatedRoute });
            } else if (this.checkoutViewModel.firstStep === 'ADDRESS') {
              this.router.navigate(['ship-address'], { relativeTo: this.activatedRoute });
            } else if (this.checkoutViewModel.firstStep === 'ENDUSER') {
              this.router.navigate(['end-user'], { relativeTo: this.activatedRoute });
            } else if (this.checkoutViewModel.firstStep === 'PAYMENT') {
              // NZ site is not using donation page
              // if (this.currentUserModel.isAU) {
              //   this.router.navigate(['donation'], { relativeTo: this.activatedRoute });
              // } else {
                this.router.navigate(['payment-method'], { relativeTo: this.activatedRoute });
              // }
            } else if (this.checkoutViewModel.firstStep === 'NOENDUSER') {
              this.router.navigate(['ship-address'], { relativeTo: this.activatedRoute });
            }
          }
        },
          (error: any) => {
            console.error(error);
            this.loadContent = true;
          });
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    }
  }


  setBackgroundClass(cartItems: CartDetailViewModel[]): void {
    this.backgroundClass = '';
    this.colorIndex = 0;
    this.previousRef = '';
    cartItems.forEach((cartItem: CartDetailViewModel) => {
      if (SubscriptionSalesType.indexOf(cartItem.salesType) > -1 && this.previousRef !== cartItem.parentStockCode) {
        if (this.colorIndex % 2 === 0) {
          this.backgroundClass = 'bgcolor-light-white';
          cartItem.backgroundClass = this.backgroundClass;
        } else {
          this.backgroundClass = 'bgcolor-light';
          cartItem.backgroundClass = this.backgroundClass;
        }

        this.colorIndex++;
        this.previousRef = cartItem.parentStockCode;
      } else if (SubscriptionSalesType.indexOf(cartItem.salesType) < 0) {
        this.backgroundClass = '';
        cartItem.backgroundClass = this.backgroundClass;
      }
    });
  }

  goToFinance(): void {
    this.router.navigate(['finance'], { relativeTo: this.activatedRoute });
  }

  sohLoad(cartItem: CartDetailViewModel): string {
    //return getStockOnHand(cartItem.stockOnHand, cartItem.maxAvailStock ? cartItem.maxAvailStock : '0', '', cartItem.freightPolicy, '');
    return this.commonService.showWebMaxQty(cartItem.stockOnHand.toString(), cartItem.maxAvailStock ? cartItem.maxAvailStock : '0');
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  open(content, event) {
    event.preventDefault();
    event.stopPropagation();
    this.modalReference = this.modalService.open(content, { centered: true });

    this.modalReference.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  createQuote() {
    // show progress
    this.loadContent = false;

    // Quote Header
    this.cartToQuote.quoteHeader = {
      accountId: this.currentUserModel.accountId,
      loginId: this.currentUserModel.loginId,
      custReference: this.cartName,
    };

    this.cartToQuote.stockLines = new Array<CartStockCodes>();

    for (let i = 0; i < this.cartItems.length; i++) {
      const stockCodes: CartStockCodes = {
        stockCode: this.cartItems[i].stockCode,
        quantity: this.cartItems[i].quantity.toString()
      };

      this.cartToQuote.stockLines.push(stockCodes);
    }
    this.convertToQuote();

  }

  convertToQuote() {
    // subscribe to api that calls send_quote_to_pronto
    const cart = JSON.stringify(this.cartToQuote);
    this.shoppingCartService.createQuoteFromCart(cart).subscribe(res => {
      if (res && res.result === 'Success') {
        // on success, route to quote that is created
        const createdQuote = res.quote;
        this.loadContent = true;
        this.commonService.implementToast('Quote ' + createdQuote + ' Created Successfuly', 'Success');
        this.router.navigate(['quotes/openQuotes/quotesItemsDetials/' + createdQuote]);
      } else {
        // on fail, show error that quote creation failed
        this.loadContent = true;
        this.commonService.implementToast('Quote Creation Unsuccessful', 'Error');
        // this.commonService.showError('.check-out-quote', 'QUOTE CREATION UNSUCCESSFUL', 'bottom');
      }
    });
  }

  close() {
    this.loadContent = true;
    this.router.navigateByUrl('/myCarts');
  }

  closePopup(notify: boolean) {
    if (notify) {
      this.modalReference.close();
      // this.store.dispatch(new LoadShoppingCartItem({ cartId: toNumber(this.cartId), shippingMethod: this.shippingMethodControl.value}));

      // this.getShoppingCarts(this.shippingMethodControl.value == 'delivery' ? "" : this.shippingMethodControl.value);
    }
  }

  sortData(sort: Sort) {
    const data = this.cartItemsFilter.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'description': return compare(a.itemDescription, b.itemDescription, isAsc);
        case 'soh': return compare(this.sohLoad(a), +this.sohLoad(b), isAsc);
        case 'price': return compare(a.unitCost, +b.unitCost, isAsc);
        case 'qty': return compare(a.quantity, +b.quantity, isAsc);
        case 'subtotal': return compare(a.subTotal, b.subTotal, isAsc);
        default: return 0;
      }
    });
  }

  navigateTo(url: string) {
    this.router.navigate([url]);
  }
  punchOut() {

  }

  public clickDonation(value: number) {
    if (value == this.selectedDonationValue) {
      const donation = this.cartItems.find(i => i.stockCode.toLowerCase().indexOf('donation') === 0);
      this.store.dispatch(new DeleteShoppingCartItem(donation));
    } else {
      this.selectedDonationValue = value;
      // this.store.dispatch(new InsertShoppingCartItem({ stockCode: 'DONATION', cartId: parseInt(this.cartId), Qty: this.selectedDonationValue.toString() }));
      this.loadContent = false;
      this.checkOutService
        .UpsertDonation(this.commonService.toNumber(this.cartId), this.selectedDonationValue)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (response) => {
            if (response) {
              this.commonService.implementToast(
                'Thank you for your donation.',
                'Success'
              );
            };
            const sc = this.shoppingCarts.map(cart => {
              if (cart.cartId.toString() === this.cartId) {
                const existingDonation = this.cartItems.find(i => i.stockCode.toLowerCase().indexOf('donation') === 0);
                if (existingDonation) {
                  cart.totalPrice = cart.totalPrice - existingDonation?.unitCost;
                  cart.totalQuantity -= 1;
                }
                
                cart.totalPrice = cart.totalPrice + this.selectedDonationValue;
                cart.totalQuantity += 1;
                this.totalPrice = cart.totalPrice;
              }
              return cart;
            });
            this.shoppingCarts = sc;
            this.shoppingCartService.setCacheShoppingCart(sc);
            this.store.dispatch(new LoadShoppingCartItem({ cartId: this.commonService.toNumber(this.cartId), shippingMethod: this.shippingMethodControl.value}));
          },
          (error: any) => {
            this.loadContent = true;
            console.log(error);
          }
        );
    }
  }

  public changeShippingMethod() {
    this.isPickUp = this.shippingMethodControl.value !== 'delivery'
    document.cookie= `PickupLocation=${ this.isPickUp ? this.shippingMethodControl.value : null };`
    localStorage.setItem('DeliveryMethod', this.shippingMethodControl.value)
    this.store.dispatch(new LoadShoppingCartItem({ cartId: this.commonService.toNumber(this.cartId), shippingMethod: this.shippingMethodControl.value}));
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}

function compare(a, b, isAsc) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

